import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { TabItem } from "../tab-menu-item/tab-menu-item";
import { style } from "./tab-menu.styles";


@customElement('sbk-tab-menu')
export class TabMenu extends LitElement {

  @property({attribute: 'align-items'})
  alignItems: 'left' | 'right' | 'center' | '' = '';

  @property({ type: Number, attribute: 'active-index' })
  activeIndex = 0;

  @property({ type: Boolean })
  fade?: boolean = true;

  static get styles() {
      return style;
  }

  render() {
    return html`
      <div class="container">
        ${this.fade ? html`<div class="fade fade-left"></div>` : ''}
        <div class="tab_container align-items--${this.alignItems}" @scroll=${this.handleScroll}>
          <slot @slotchange=${this.handleSlotChange}></slot>
        </div>
        ${this.fade ? html`<div class="fade fade-right"></div>` : ''}
      </div>
    `;
  }

  firstUpdated() {
    requestAnimationFrame(() => {
      this.updateScrollPosition();
      this.handleScroll();
    });
  }

  updateScrollPosition = () => {
    const slot = this.shadowRoot?.querySelector('slot');
    const tabContainer = this.shadowRoot?.querySelector('.tab_container') as HTMLElement;

    if (slot) {
      const slottedElements = slot.assignedElements();
      if (tabContainer && slottedElements.length > 0) {
        const activeItem = slot.assignedElements().filter((node) => node.matches('[active]'))[0] as HTMLElement;
        if (tabContainer.scrollWidth > tabContainer.clientWidth && activeItem) {
          const computedStyle = window.getComputedStyle(this) as CSSStyleDeclaration;
          const paddingLeft = parseFloat(computedStyle.paddingLeft);

          const containerComputedStyle = window.getComputedStyle(tabContainer) as CSSStyleDeclaration;
          const gap = parseFloat(containerComputedStyle.gap);
          tabContainer.scrollLeft = Math.max(0, activeItem.offsetLeft - paddingLeft - gap);
          activeItem.focus();
        }
      }
    }
  }

  handleScroll() {
    const container = this.shadowRoot?.querySelector('.tab_container') as HTMLElement;
    const fadeLeft = this.shadowRoot?.querySelector('.fade-left') as HTMLElement;
    const fadeRight = this.shadowRoot?.querySelector('.fade-right') as HTMLElement;

    if (container && fadeLeft && fadeRight) {
      if (container.scrollLeft > 0) {
        fadeLeft.style.display = 'block';
      } else {
        fadeLeft.style.display = 'none';
      }

      if (container.scrollWidth > container.clientWidth && container.scrollLeft < container.scrollWidth - container.clientWidth) {
        fadeRight.style.display = 'block';
      } else {
        fadeRight.style.display = 'none';
      }
    }
  }

  handleSlotChange() {
    const tabs = this.querySelectorAll('sbk-tab-menu-item') as NodeListOf<TabItem>;
    tabs.forEach((tab, index) => {
        tab.active = index === this.activeIndex;
        tab.setAttribute('index', index.toString());
        tab.removeEventListener('click', this.handleTabClick);
        tab.addEventListener('click', this.handleTabClick);
    });
  }

  handleTabClick = (event: Event) => {
      const target = event.currentTarget as HTMLElement;
      const index = parseInt(target.getAttribute('index')!, 10);
      this.setActiveTab(index);
  };

  setActiveTab(index: number) {
    this.activeIndex = index;
    this.handleSlotChange();
    this.dispatchEvent(new CustomEvent('tab-change', { detail: { index } }));
  }
}
